export default "__VITE_ASSET__T3rl6WSW__"